import { LEAD_REQUIREMENTS_MAX, NOTES_MIN_CHARS_MAX } from '@viq-admin/types';

/** User-facing words for company lead rules (spec 2026-09-14 §3). */
export const LEAD_RULES_COPY = {
  title: 'Lead rules',
  enforcementLabel: 'Enforcement',
  enforcement: {
    off: { label: 'Off', help: 'Nothing is checked. Leads are never flagged and sending works as it does today.' },
    flag: { label: 'Flag only', help: 'Leads that miss a requirement are flagged. Nothing is blocked.' },
    block: {
      label: 'Flag + block send',
      help: 'Also holds back leads that are below the notes minimum, or missing a field VendoIQ staff hold. Other questions and fields only flag.',
    },
  },
  requirementsLabel: 'Requirements',
  empty: 'No requirements yet.',
  addRequirement: 'Add requirement',
  addType: {
    notes_min_chars: 'Notes minimum',
    question_answered: 'Discovery question answered',
    field_present: 'Lead field filled in',
  },
  notesSuffix: 'characters across all notes',
  questionSelectLabel: 'Discovery question',
  fieldSelectLabel: 'Lead field',
  remove: 'Remove',
  questionDeleted: 'Question deleted — no longer checked',
  coveragePending: 'Coverage is shown after saving.',
  blockWithoutNotes: 'Block has no effect without a notes minimum or a held field.',
  /** Console only (spec 2026-09-28 §6). */
  holdLabel: 'Hold the lead until filled',
  holdHelp: 'A held field keeps the lead out of CRM sends until it is filled. Holds work only with “Flag + block send”.',
  /** Send's Not-ready reason for held fields: "Missing: Last name, Company". */
  heldPrefix: 'Missing:',
  limitReached: `You can have up to ${LEAD_REQUIREMENTS_MAX} requirements.`,
  notesRange: `Enter a whole number from 1 to ${NOTES_MIN_CHARS_MAX}.`,
  duplicateQuestion: 'This question is already required.',
  duplicateField: 'This field is already required.',
  duplicateNotes: 'Only one notes minimum is allowed.',
  save: 'Save',
  discard: 'Discard',
  saved: 'Lead rules saved.',
  saveFailed: 'Could not save lead rules.',
  loadFailed: 'Could not load lead rules.',
  retry: 'Retry',
  conflictTitle: 'Someone else changed these rules',
  conflictBody: 'Reload to see their version. Your unsaved changes will be lost.',
  reload: 'Reload',
  lastSaved: (who: string, when: string) => `Last saved by ${who} on ${when}`,
  checklistTitle: 'Lead requirements',
  checklistComplete: 'Meets every lead requirement.',
  sendBlockedLine: (need: number) => `Held back from CRM sends until the notes reach ${need} characters.`,
  notesCounterHelp: (need: number) => `Characters across all of this lead’s notes (minimum ${need}).`,
  // Total Notes tile captions (Task B6). They live here, not inline in
  // notesTile.ts, because every user-facing string in this module is data.
  notesTileOk: 'Every unsent lead meets the notes minimum',
  notesTileShort: (count: number) => `${count} ${count === 1 ? 'lead' : 'leads'} below the notes minimum`,
  // Leads table incomplete flag (Task B7): the Name-cell tag for an
  // incomplete, unsent lead. Lives here, not inline in BatchTable.tsx, for
  // the same reason as the Total Notes tile captions above.
  incompleteTag: 'Incomplete',
} as const;
